export default "<div class=\"text-center preloader\" *ngIf=\"show\">\n  <i class=\"fa fa-spinner fa-spin\"></i> Please wait ...\n</div>\n"